<script setup lang="ts">
/**
 * The checkout of the interview prep (LemonSqueezy, or Stripe in crowns),
 * kept in-page like every other guest purchase so the visitor never loses
 * what they were reading.
 */
const url = defineModel<string | null>({ required: true })
const { t } = useI18n()
</script>

<template>
  <Teleport to="body">
    <div v-if="url" class="sofax fixed inset-0 z-[1300] flex items-center justify-center bg-black/70 p-2 sm:p-4">
      <div class="relative h-[92vh] w-full max-w-5xl overflow-hidden rounded-[0.625rem] bg-white shadow-lift dark:bg-gray-900">
        <button
          type="button"
          class="social-link absolute right-3 top-3 z-10 shadow-lift"
          :aria-label="t('common.close')"
          @click="url = null"
        >
          <i class="bi bi-x-lg" />
        </button>
        <CommonCheckoutLoading />
        <CommonCheckoutEmbed :src="url" />
      </div>
    </div>
  </Teleport>
</template>
